module.exports = __webpack_public_path__ + "static/media/ic_people.750fc9f9.svg";